import { useContext } from "react";
import { AuthContext } from "../Context/AuthContext";
import { Avatar, IconButton, Stack, Tooltip } from "@mui/material";
import CamFlag from "../Assets/Cambodia.png";
import EngFlag from "../Assets/United_Kingdom.png";
import "./layout.scss";

export default function ChangeLanguage({ size = "35px" }) {
  // ========================= Change Language ============================
  const { language, changeLanguage } = useContext(AuthContext);

  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      {language === "en" ? (
        <Tooltip title="Change to Khmer" placement="left">
          <IconButton
            onClick={() => changeLanguage("kh")}
            sx={{ padding: "2px !important" }}
          >
            <Avatar src={EngFlag} sx={{ width: size, height: size }} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Change to English" placement="left">
          <IconButton
            onClick={() => changeLanguage("en")}
            sx={{ padding: "2px !important" }}
          >
            <Avatar src={CamFlag} sx={{ width: size, height: size }} />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}
